
    import {PageRequest} from '@/store/shared/entity'
    import CreateFactory from './component/create-factory.vue'
    import EditFactory from './component/edit-factory.vue'
    import { Component, Mixins, ActionButtonConfig, PageResultBaseMixins, PageResultModalMixins } from "@/lib";

    class  PageFactoryRequest extends PageRequest{
        name:string;
        shortName:string;
    }

    @Component({
 name: "factory",
        components:{CreateFactory,EditFactory}
    })
    export default class Factorys extends  Mixins(PageResultBaseMixins,PageResultModalMixins){
        buttons = { ...this.addBtn() };

        data:any = {
            model: new PageFactoryRequest(),
            queryAction:"system/factory/getAll",
            isAutoQuery: true,
            cols:this.columns
        }

        get columns(){
            return [
                { title:this.L('app.Factory.Name'), key:'name',width: 360},
                { title:this.L('app.Factory.ShortName'), key:'shortName', width: 160, tooltip: true },
                { title:this.L('app.Factory.DomesticSourceOfGood'), key:'domesticSourceOfGood', width: 160, tooltip: true },
                { title:this.L('app.Factory.Remark'), key:'remark', tooltip: true },
                this.$util.render.actions(this.colButtons)
            ]
        }

        colButtonCheck = (row) => {
            return !row.isStatic;
        }

        get colButtons():ActionButtonConfig[]{ 
            return [
                this.colEditBtnM(row => this.colButtonCheck(row)),
                this.colDeleteBtn( row => this.colButtonCheck(row)),
            ]
        }

        async created(){
            // await this.$store.dispatch({
            //     type:'system/factory/getRoles'
            // })
        }

        reset(){
            this.data.model = new PageFactoryRequest();
        }
    }
